"use client"

import React, { useState, useEffect, useMemo, useCallback } from 'react'
import { transactionsAPI, usersAPI, bankAccountsAPI } from 'services/api.js'

// ─── YARDIMCI FONKSİYONLAR ───────────────────────────────────────────────────
const formatCurrency = (val) =>
    new Intl.NumberFormat('tr-TR', { style: 'currency', currency: 'TRY' }).format(Number(val) || 0)

const formatDate = (dateString) => {
    if (!dateString) return '-'
    const date = new Date(dateString)
    return new Intl.DateTimeFormat('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric' }).format(date)
}

const getStartOfWeek = () => {
    const d = new Date()
    const day = d.getDay()
    const diff = d.getDate() - day + (day === 0 ? -6 : 1)
    d.setDate(diff)
    d.setHours(0, 0, 0, 0)
    return d
}

const isToday = (dateString) => {
    const d = new Date(dateString)
    const today = new Date()
    return (
        d.getDate() === today.getDate() &&
        d.getMonth() === today.getMonth() &&
        d.getFullYear() === today.getFullYear()
    )
}

const isThisWeek = (dateString) => {
    const d = new Date(dateString)
    const start = getStartOfWeek()
    const end = new Date(start)
    end.setDate(end.getDate() + 7)
    return d >= start && d < end
}

const PAGE_SIZE = 10

// ─── SVG İKONLAR ─────────────────────────────────────────────────────────────
const IconHistory = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8"/><path d="M3 3v5h5"/><path d="M12 7v5l4 2"/></svg>
const IconTrendUp = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
const IconTrendDown = () => <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="23 18 13.5 8.5 8.5 13.5 1 6"/><polyline points="17 18 23 18 23 12"/></svg>
const IconSearch = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
const IconEdit = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
const IconTrash = () => <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6m3 0V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2"/></svg>
const IconCash = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="6" width="20" height="12" rx="2"/><circle cx="12" cy="12" r="2"/><path d="M6 12h.01M18 12h.01"/></svg>
const IconCard = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="1" y="4" width="22" height="16" rx="2"/><line x1="1" y1="10" x2="23" y2="10"/></svg>
const IconUser = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
const IconCalendar = () => <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
const IconWarning = () => <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"/><line x1="12" y1="9" x2="12" y2="13"/><line x1="12" y1="17" x2="12.01" y2="17"/></svg>
const IconCheckCircle = () => <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
const IconBank = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="3" y1="22" x2="21" y2="22"/><line x1="6" y1="18" x2="6" y2="11"/><line x1="10" y1="18" x2="10" y2="11"/><line x1="14" y1="18" x2="14" y2="11"/><line x1="18" y1="18" x2="18" y2="11"/><polygon points="12 2 20 7 4 7"/></svg>
const IconX = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
const IconChevronLeft = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"/></svg>
const IconChevronRight = () => <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"/></svg>
const IconSpinner = ({ size = 16 }) => <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="animate-spin"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>

// ─── SKELETON LOADER (Tailwind) ───────────────────────────────────────────────
const SkeletonStatCard = () => (
    <div className="bg-white dark:bg-navy-800 rounded-[20px] border border-gray-100 dark:border-white/10 p-6 flex justify-between items-center shadow-sm animate-pulse">
        <div className="flex-1">
            <div className="h-3 w-20 bg-gray-200 dark:bg-navy-700 rounded mb-3" />
            <div className="h-7 w-32 bg-gray-200 dark:bg-navy-700 rounded-xl mb-2" />
            <div className="h-3 w-16 bg-gray-200 dark:bg-navy-700 rounded" />
        </div>
        <div className="h-14 w-14 rounded-xl bg-gray-200 dark:bg-navy-700" />
    </div>
)

const SkeletonRow = () => (
    <tr className="border-b border-gray-100 dark:border-white/10 animate-pulse">
        {[80, 140, 90, 80, 100, 70].map((w, i) => (
            <td key={i} className="py-4 px-4">
                <div className="h-3 bg-gray-200 dark:bg-navy-700 rounded" style={{ width: w }} />
            </td>
        ))}
    </tr>
)

const SkeletonCard = () => (
    <div className="bg-white dark:bg-navy-800 rounded-[20px] p-5 mb-4 border border-gray-100 dark:border-white/10 shadow-sm animate-pulse">
        <div className="flex justify-between mb-4">
            <div className="h-4 w-32 bg-gray-200 dark:bg-navy-700 rounded" />
            <div className="h-4 w-20 bg-gray-200 dark:bg-navy-700 rounded" />
        </div>
        <div className="flex gap-3 mb-4">
            <div className="h-3 w-20 bg-gray-200 dark:bg-navy-700 rounded" />
            <div className="h-3 w-20 bg-gray-200 dark:bg-navy-700 rounded" />
        </div>
        <div className="flex justify-end gap-2 pt-4 border-t border-gray-100 dark:border-white/10">
            <div className="h-8 w-8 bg-gray-200 dark:bg-navy-700 rounded-lg" />
            <div className="h-8 w-8 bg-gray-200 dark:bg-navy-700 rounded-lg" />
        </div>
    </div>
)

// ─── CUSTOM SELECT (Tailwind) ───────────────────────────────────────────────────
const HzSelect = ({ value, onChange, options, placeholder }) => {
    const [open, setOpen] = useState(false)
    const selected = options.find(o => o.value === value)

    return (
        <div className="relative">
            <button
                type="button"
                onClick={() => setOpen(o => !o)}
                className="w-full flex items-center justify-between px-4 py-3 rounded-xl border border-gray-200 dark:border-white/10 bg-gray-50 dark:bg-navy-900 text-sm font-bold text-navy-700 dark:text-white focus:outline-none focus:border-brand-500 transition-all"
            >
                <span>{selected ? selected.label : (placeholder || 'Seçiniz...')}</span>
                <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" className={`transition-transform duration-200 ${open ? 'rotate-180' : ''}`}>
                    <polyline points="6 9 12 15 18 9"/>
                </svg>
            </button>
            {open && (
                <div className="absolute top-full left-0 right-0 mt-1 z-50 bg-white dark:bg-navy-800 border border-gray-100 dark:border-white/10 rounded-xl shadow-xl overflow-hidden">
                    {options.map(opt => (
                        <button
                            key={opt.value}
                            type="button"
                            onClick={() => { onChange(opt.value); setOpen(false) }}
                            className={`w-full text-left px-4 py-2.5 text-sm font-medium transition-colors hover:bg-gray-50 dark:hover:bg-navy-700 ${opt.value === value ? 'text-brand-500 bg-brand-50 dark:bg-brand-400/10' : 'text-gray-600 dark:text-gray-300'}`}
                        >
                            {opt.label}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )
}

// ─── MODAL (Tailwind) ──────────────────────────────────────────────────────────
const HzModal = ({ visible, onClose, title, children, footer }) => {
    if (!visible) return null
    return (
        <div className="fixed inset-0 z-[100] flex items-center justify-center bg-navy-900/60 backdrop-blur-sm p-4 animate-fadeIn" onClick={e => { if (e.target === e.currentTarget) onClose() }}>
            <div className="w-full max-w-md bg-white dark:bg-navy-800 rounded-[24px] shadow-2xl border border-gray-100 dark:border-white/10 overflow-hidden transform transition-all">
                <div className="flex items-center justify-between p-6 border-b border-gray-100 dark:border-white/10">
                    <h3 className="text-lg font-bold text-navy-700 dark:text-white">{title}</h3>
                    <button onClick={onClose} className="text-gray-400 hover:text-gray-600 dark:hover:text-white transition-colors">
                        <IconX />
                    </button>
                </div>
                <div className="p-6">
                    {children}
                </div>
                {footer && (
                    <div className="p-6 pt-0 flex justify-end gap-3">
                        {footer}
                    </div>
                )}
            </div>
        </div>
    )
}

// ─── ANA COMPONENT ────────────────────────────────────────────────────────────
const Vault_Transaction_History = () => {
    const [loading, setLoading] = useState(true)
    const [transactions, setTransactions] = useState([])
    const [staffList, setStaffList] = useState([])
    const [bankList, setBankList] = useState([])
    const [viewMode, setViewMode] = useState('week')
    const [typeFilter, setTypeFilter] = useState('all')
    const [search, setSearch] = useState('')
    const [currentPage, setCurrentPage] = useState(1)
    const [modal, setModal] = useState({ visible: false, type: '', data: null })
    const [isSubmitting, setIsSubmitting] = useState(false)

    // ─── VERİ ÇEKME (WORK-LOGIC BİREBİR) ─────────────────────────────────────────
    const fetchData = useCallback(async () => {
        setLoading(true)
        try {
            const [transRes, staffRes, bankRes] = await Promise.all([
                transactionsAPI.getAll(),
                usersAPI.getStaff(),
                bankAccountsAPI.getAll()
            ])
            if (transRes.success) {
                const sorted = (transRes.transactions || []).sort((a, b) => new Date(b.date) - new Date(a.date))
                setTransactions(sorted)
            }
            if (staffRes.success) setStaffList(staffRes.staff || [])
            if (bankRes.success) setBankList(bankRes.bank_accounts || [])
        } catch (err) {
            console.error(err)
        } finally {
            setLoading(false)
        }
    }, [])

    useEffect(() => { fetchData() }, [fetchData])

    // ─── MANTIK VE HESAPLAMALAR (WORK-LOGIC BİREBİR) ──────────────────────────
    const dateFilteredData = useMemo(() => {
        return transactions.filter(t => {
            if (viewMode === 'today') return isToday(t.date)
            if (viewMode === 'week') return isThisWeek(t.date)
            return true
        })
    }, [transactions, viewMode])

    const stats = useMemo(() => {
        return dateFilteredData.reduce(
            (acc, curr) => {
                if (curr.type === 'income') acc.income += parseFloat(curr.amount)
                else if (curr.type === 'expense') acc.expense += parseFloat(curr.amount)
                return acc
            },
            { income: 0, expense: 0 }
        )
    }, [dateFilteredData])

    const finalData = useMemo(() => {
        return dateFilteredData.filter(t => {
            const matchesType = typeFilter === 'all' || t.type === typeFilter
            const matchesSearch =
                t.title.toLowerCase().includes(search.toLowerCase()) ||
                (t.description && t.description.toLowerCase().includes(search.toLowerCase()))
            return matchesType && matchesSearch
        })
    }, [dateFilteredData, typeFilter, search])

    const detailedReport = useMemo(() => {
        let summary = {
            totalIncome: 0, totalExpense: 0, totalFees: 0, netProfit: 0,
            cashIncome: 0, cardIncome: 0, cashExpense: 0, cardExpense: 0
        }
        let bankStats = {}
        const bankNameMap = {}
        bankList.forEach(b => {
            bankStats[b.id] = { name: b.name, amount: 0, expense: 0, fee: 0, net: 0 }
            bankNameMap[b.id] = b.name
        })
        let staffStats = {}
        staffList.forEach(s => {
            staffStats[s.id] = {
                name: `${s.name} ${s.surname}`,
                income: 0, incomeCash: 0, incomeCardTotal: 0, incomeBankBreakdown: {},
                expense: 0, expenseCash: 0, expenseCardTotal: 0, expenseBankBreakdown: {}
            }
        })
        dateFilteredData.forEach(t => {
            const amt = parseFloat(t.amount) || 0
            const fee = parseFloat(t.fee_amount) || 0
            if (t.type === 'income') {
                summary.totalIncome += amt
                summary.totalFees += fee
                if (t.payment_method === 'cash') {
                    summary.cashIncome += amt
                } else {
                    summary.cardIncome += amt
                    if (t.bank_account_id && bankStats[t.bank_account_id]) {
                        bankStats[t.bank_account_id].amount += amt
                        bankStats[t.bank_account_id].fee += fee
                        bankStats[t.bank_account_id].net += (amt - fee)
                    }
                }
                if (t.staff_id && staffStats[t.staff_id]) {
                    const s = staffStats[t.staff_id]
                    s.income += amt
                    if (t.payment_method === 'cash') { s.incomeCash += amt }
                    else {
                        s.incomeCardTotal += amt
                        if (t.bank_account_id) {
                            if (!s.incomeBankBreakdown[t.bank_account_id]) s.incomeBankBreakdown[t.bank_account_id] = 0
                            s.incomeBankBreakdown[t.bank_account_id] += amt
                        }
                    }
                }
            } else if (t.type === 'expense') {
                summary.totalExpense += amt
                if (t.payment_method === 'cash') {
                    summary.cashExpense += amt
                } else {
                    summary.cardExpense += amt
                    if (t.bank_account_id && bankStats[t.bank_account_id]) {
                        bankStats[t.bank_account_id].expense += amt
                        bankStats[t.bank_account_id].net -= amt
                    }
                }
                if (t.staff_id && staffStats[t.staff_id]) {
                    const s = staffStats[t.staff_id]
                    s.expense += amt
                    if (t.payment_method === 'cash') { s.expenseCash += amt }
                    else {
                        s.expenseCardTotal += amt
                        if (t.bank_account_id) {
                            if (!s.expenseBankBreakdown[t.bank_account_id]) s.expenseBankBreakdown[t.bank_account_id] = 0
                            s.expenseBankBreakdown[t.bank_account_id] += amt
                        }
                    }
                }
            }
        })
        summary.netProfit = summary.totalIncome - summary.totalExpense - summary.totalFees
        return { summary, bankStats, staffStats, bankNameMap }
    }, [dateFilteredData, bankList, staffList])

    // ─── SAYFALAMA ────────────────────────────────────────────────────────────
    const totalPages = Math.ceil(finalData.length / PAGE_SIZE)
    const currentItems = finalData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE)

    // ─── HANDLERS ─────────────────────────────────────────────────────────────
    const handleModeChange = (mode) => { setViewMode(mode); setTypeFilter('all'); setCurrentPage(1) }
    const toggleTypeFilter = (type) => { setTypeFilter(f => f === type ? 'all' : type); setCurrentPage(1) }

    const handleEdit = (item) => {
        setModal({
            visible: true, type: 'edit',
            data: {
                ...item,
                amount: parseFloat(item.amount),
                date: item.date.split('T')[0],
                payment_method: item.payment_method || 'cash',
                bank_account_id: item.bank_account_id || ''
            }
        })
    }

    const handleDelete = (item) => setModal({ visible: true, type: 'delete', data: item })

    const saveChanges = async () => {
        const { data, type } = modal
        setIsSubmitting(true)
        try {
            if (type === 'delete') {
                await transactionsAPI.delete(data.id)
                setTransactions(prev => prev.filter(t => t.id !== data.id))
            } else if (type === 'edit') {
                const payload = { ...data, bank_account_id: data.payment_method === 'cash' ? null : data.bank_account_id }
                const res = await transactionsAPI.update(data.id, payload)
                if (res.success) {
                    setTransactions(prev =>
                        prev.map(t => t.id === data.id ? res.transaction : t)
                            .sort((a, b) => new Date(b.date) - new Date(a.date))
                    )
                }
            }
            setModal({ visible: false, type: '', data: null })
        } catch (err) {
            alert('Hata: ' + (err.response?.data?.message || err.message))
        } finally {
            setIsSubmitting(false)
        }
    }

    // ─── RENDER ───────────────────────────────────────────────────────────────
    return (
        <div className="mt-5 flex w-full flex-col gap-6 pb-20 animate-fadeIn">

            {/* ── 1. BAŞLIK + SEGMENT ── */}
            <div className="flex flex-col md:flex-row items-center justify-between gap-4 bg-white p-6 rounded-[20px] shadow-3xl shadow-shadow-500 dark:bg-navy-800 dark:shadow-none border border-gray-100 dark:border-white/10">
                <div className="flex items-center gap-4 w-full md:w-auto">
                    <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-brand-50 text-brand-500 dark:bg-brand-400/10 dark:text-brand-400 flex-none">
                        <IconHistory />
                    </div>
                    <div>
                        <h4 className="text-xl font-bold text-navy-700 dark:text-white">Kasa Hareketleri</h4>
                        <p className="text-sm font-medium text-gray-500 dark:text-gray-400">Günlük ve haftalık işlem takibi</p>
                    </div>
                </div>
                <div className="flex p-1 bg-gray-50 dark:bg-navy-900 rounded-xl w-full md:w-auto border border-gray-100 dark:border-white/5">
                    <button
                        className={`flex-1 md:flex-none px-6 py-2 text-sm font-bold rounded-lg transition-all ${viewMode === 'today' ? 'bg-white dark:bg-navy-800 text-brand-500 shadow-sm' : 'text-gray-500 hover:text-navy-700 dark:hover:text-white'}`}
                        onClick={() => handleModeChange('today')}
                    >BUGÜN</button>
                    <button
                        className={`flex-1 md:flex-none px-6 py-2 text-sm font-bold rounded-lg transition-all ${viewMode === 'week' ? 'bg-white dark:bg-navy-800 text-brand-500 shadow-sm' : 'text-gray-500 hover:text-navy-700 dark:hover:text-white'}`}
                        onClick={() => handleModeChange('week')}
                    >BU HAFTA</button>
                </div>
            </div>

            {/* ── 2. ÖZET STAT KARTLARI ── */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                {loading ? (
                    <>
                        <SkeletonStatCard />
                        <SkeletonStatCard />
                    </>
                ) : (
                    <>
                        {/* GELİR KARTI */}
                        <div
                            className={`cursor-pointer transition-all duration-300 rounded-[20px] p-6 shadow-sm border flex items-center justify-between ${typeFilter === 'income' ? 'bg-green-50/50 dark:bg-green-500/5 border-green-500' : 'bg-white dark:bg-navy-800 border-gray-100 dark:border-white/10 hover:shadow-md'}`}
                            onClick={() => toggleTypeFilter('income')}
                        >
                            <div className="flex-1">
                                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">TOPLAM GELİR</p>
                                <p className="text-3xl font-black text-green-500 truncate" title={formatCurrency(stats.income)}>
                                    {formatCurrency(stats.income)}
                                </p>
                                <p className="text-xs font-medium text-gray-500 mt-1">
                                    {viewMode === 'today' ? 'Bugüne ait' : 'Bu haftaya ait'}
                                </p>
                            </div>
                            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-green-50 dark:bg-green-500/10 text-green-500 flex-none">
                                <IconTrendUp />
                            </div>
                        </div>

                        {/* GİDER KARTI */}
                        <div
                            className={`cursor-pointer transition-all duration-300 rounded-[20px] p-6 shadow-sm border flex items-center justify-between ${typeFilter === 'expense' ? 'bg-red-50/50 dark:bg-red-500/5 border-red-500' : 'bg-white dark:bg-navy-800 border-gray-100 dark:border-white/10 hover:shadow-md'}`}
                            onClick={() => toggleTypeFilter('expense')}
                        >
                            <div className="flex-1">
                                <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">TOPLAM GİDER</p>
                                <p className="text-3xl font-black text-red-500 truncate" title={formatCurrency(stats.expense)}>
                                    {formatCurrency(stats.expense)}
                                </p>
                                <p className="text-xs font-medium text-gray-500 mt-1">
                                    {viewMode === 'today' ? 'Bugüne ait' : 'Bu haftaya ait'}
                                </p>
                            </div>
                            <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-red-50 dark:bg-red-500/10 text-red-500 flex-none">
                                <IconTrendDown />
                            </div>
                        </div>
                    </>
                )}
            </div>

            {/* ── 3. ARAMA ── */}
            <div className="relative w-full">
                <div className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none">
                    <IconSearch />
                </div>
                <input
                    className="w-full h-12 pl-12 pr-4 rounded-xl border border-gray-200 bg-white text-sm font-medium text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-800 dark:text-white transition-all shadow-sm"
                    placeholder="İşlem veya açıklama ara..."
                    value={search}
                    onChange={e => { setSearch(e.target.value); setCurrentPage(1) }}
                />
            </div>

            {/* ── 4. LİSTELEME ── */}
            {loading ? (
                <>
                    {/* Mobil skeleton */}
                    <div className="md:hidden flex flex-col gap-4">
                        {[1,2,3,4].map(i => <SkeletonCard key={i} />)}
                    </div>
                    {/* Desktop skeleton */}
                    <div className="hidden md:block bg-white dark:bg-navy-800 rounded-[20px] p-4 border border-gray-100 dark:border-white/10 shadow-sm overflow-hidden">
                        <table className="w-full text-left border-collapse">
                            <thead>
                            <tr>
                                {['Tarih', 'İşlem', 'Personel', 'Ödeme', 'Tutar', 'İşlem'].map((h, i) => (
                                    <th key={i} className={`p-4 text-xs font-bold text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-white/10 ${i >= 4 ? 'text-right' : ''}`}>{h}</th>
                                ))}
                            </tr>
                            </thead>
                            <tbody>
                            {[1,2,3,4,5].map(i => <SkeletonRow key={i} />)}
                            </tbody>
                        </table>
                    </div>
                </>
            ) : currentItems.length === 0 ? (
                <div className="flex flex-col items-center justify-center py-20 bg-white dark:bg-navy-800 rounded-[20px] border border-gray-100 dark:border-white/10 border-dashed opacity-70">
                    <div className="text-5xl mb-3">🔍</div>
                    <p className="text-lg font-bold text-navy-700 dark:text-white">İşlem bulunamadı.</p>
                </div>
            ) : (
                <>
                    {/* ── MOBİL KARTLAR ── */}
                    <div className="md:hidden flex flex-col gap-4">
                        {currentItems.map(item => {
                            const isIncome = item.type === 'income'
                            const staff = staffList.find(s => s.id === item.staff_id)
                            const bank = bankList.find(b => b.id === item.bank_account_id)
                            return (
                                <div key={item.id} className={`bg-white dark:bg-navy-800 rounded-[20px] p-5 shadow-sm border border-gray-100 dark:border-white/10 border-l-4 ${isIncome ? 'border-l-green-500' : 'border-l-red-500'}`}>
                                    <div className="flex justify-between items-start mb-3">
                                        <span className="font-bold text-navy-700 dark:text-white pr-2 flex-1">{item.title}</span>
                                        <span className={`font-black whitespace-nowrap ${isIncome ? 'text-green-500' : 'text-red-500'}`}>
                                            {isIncome ? '+' : '-'} {formatCurrency(item.amount)}
                                        </span>
                                    </div>
                                    <div className="flex flex-wrap items-center gap-3 mb-4">
                                        <span className="flex items-center gap-1 text-xs font-medium text-gray-500 dark:text-gray-400">
                                            <IconCalendar /> {formatDate(item.date)}
                                        </span>
                                        <span className={`flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2 py-1 rounded-md ${item.payment_method === 'card' ? 'bg-brand-50 text-brand-500 dark:bg-brand-400/10 dark:text-brand-400' : 'bg-green-50 text-green-600 dark:bg-green-500/10 dark:text-green-400'}`}>
                                            {item.payment_method === 'card' ? <IconCard /> : <IconCash />}
                                            {item.payment_method === 'card' ? (bank?.name || 'Kart') : 'Nakit'}
                                        </span>
                                        {staff && (
                                            <span className="flex items-center gap-1 text-xs font-bold text-orange-500">
                                                <IconUser /> {staff.name}
                                            </span>
                                        )}
                                    </div>
                                    <div className="h-px bg-gray-100 dark:bg-white/10 w-full mb-3" />
                                    <div className="flex justify-end gap-2">
                                        <button onClick={() => handleEdit(item)} className="flex h-9 w-9 items-center justify-center rounded-lg bg-blue-50 text-blue-500 hover:bg-blue-500 hover:text-white dark:bg-blue-500/10 dark:text-blue-400 dark:hover:bg-blue-500 dark:hover:text-white transition-all"><IconEdit /></button>
                                        <button onClick={() => handleDelete(item)} className="flex h-9 w-9 items-center justify-center rounded-lg bg-red-50 text-red-500 hover:bg-red-500 hover:text-white dark:bg-red-500/10 dark:text-red-400 dark:hover:bg-red-500 dark:hover:text-white transition-all"><IconTrash /></button>
                                    </div>
                                </div>
                            )
                        })}
                    </div>

                    {/* ── MASAÜSTÜ TABLO ── */}
                    <div className="hidden md:block bg-white dark:bg-navy-800 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10 overflow-hidden">
                        <div className="overflow-x-auto">
                            <table className="w-full text-left border-collapse">
                                <thead>
                                <tr>
                                    <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20">Tarih</th>
                                    <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20">İşlem</th>
                                    <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20">Personel</th>
                                    <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20">Ödeme</th>
                                    <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20 text-right">Tutar</th>
                                    <th className="p-4 text-xs font-bold text-gray-400 uppercase tracking-wide border-b border-gray-100 dark:border-white/10 bg-gray-50/50 dark:bg-navy-900/20 text-right w-24">Aksiyon</th>
                                </tr>
                                </thead>
                                <tbody>
                                {currentItems.map(item => {
                                    const isIncome = item.type === 'income'
                                    const staff = staffList.find(s => s.id === item.staff_id)
                                    const bank = bankList.find(b => b.id === item.bank_account_id)
                                    return (
                                        <tr key={item.id} className="hover:bg-gray-50 dark:hover:bg-navy-900/50 transition-colors border-b border-gray-100 dark:border-white/10 last:border-none">
                                            <td className="p-4">
                                                <span className="flex items-center gap-1 text-sm font-medium text-gray-500 dark:text-gray-400">
                                                    <IconCalendar /> {formatDate(item.date)}
                                                </span>
                                            </td>
                                            <td className="p-4">
                                                <span className="font-bold text-navy-700 dark:text-white">{item.title}</span>
                                                {item.description && <p className="text-xs font-medium text-gray-500 mt-1 line-clamp-1">{item.description}</p>}
                                            </td>
                                            <td className="p-4">
                                                {staff ? (
                                                    <span className="flex items-center gap-1 text-sm font-bold text-orange-500">
                                                        <IconUser />{staff.name}
                                                    </span>
                                                ) : <span className="text-gray-400">—</span>}
                                            </td>
                                            <td className="p-4">
                                                <span className={`inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-wider px-2.5 py-1 rounded-md ${item.payment_method === 'card' ? 'bg-brand-50 text-brand-500 dark:bg-brand-400/10 dark:text-brand-400' : 'bg-green-50 text-green-600 dark:bg-green-500/10 dark:text-green-400'}`}>
                                                    {item.payment_method === 'card' ? <IconCard /> : <IconCash />}
                                                    {item.payment_method === 'card' ? (bank?.name || 'Kart') : 'Nakit'}
                                                </span>
                                            </td>
                                            <td className="p-4 text-right">
                                                <span className={`font-black text-[15px] ${isIncome ? 'text-green-500' : 'text-red-500'}`}>
                                                    {isIncome ? '+' : '-'} {formatCurrency(item.amount)}
                                                </span>
                                            </td>
                                            <td className="p-4 text-right">
                                                <div className="flex gap-2 justify-end">
                                                    <button onClick={() => handleEdit(item)} className="flex h-8 w-8 items-center justify-center rounded-lg bg-blue-50 text-blue-500 hover:bg-blue-500 hover:text-white dark:bg-blue-500/10 dark:text-blue-400 dark:hover:bg-blue-500 dark:hover:text-white transition-all" title="Düzenle"><IconEdit /></button>
                                                    <button onClick={() => handleDelete(item)} className="flex h-8 w-8 items-center justify-center rounded-lg bg-red-50 text-red-500 hover:bg-red-500 hover:text-white dark:bg-red-500/10 dark:text-red-400 dark:hover:bg-red-500 dark:hover:text-white transition-all" title="Sil"><IconTrash /></button>
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                })}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {/* ── PAGINATION ── */}
                    {totalPages > 1 && (
                        <div className="flex items-center justify-center gap-2 mt-6">
                            <button disabled={currentPage === 1} onClick={() => setCurrentPage(p => p - 1)} className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all">
                                <IconChevronLeft />
                            </button>

                            {(() => {
                                const pages = []
                                const delta = 2
                                for (let i = Math.max(1, currentPage - delta); i <= Math.min(totalPages, currentPage + delta); i++) { pages.push(i) }
                                const items = []
                                if (pages[0] > 1) {
                                    items.push(<button key={1} className={`flex h-9 w-9 items-center justify-center rounded-lg text-sm font-bold transition-all ${currentPage === 1 ? 'bg-brand-500 text-white shadow-md' : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-navy-700'}`} onClick={() => setCurrentPage(1)}>1</button>)
                                    if (pages[0] > 2) items.push(<span key="l-ellipsis" className="px-1 text-gray-400 font-bold">...</span>)
                                }
                                pages.forEach(p => {
                                    items.push(<button key={p} className={`flex h-9 w-9 items-center justify-center rounded-lg text-sm font-bold transition-all ${p === currentPage ? 'bg-brand-500 text-white shadow-md' : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-navy-700'}`} onClick={() => setCurrentPage(p)}>{p}</button>)
                                })
                                if (pages[pages.length - 1] < totalPages) {
                                    if (pages[pages.length - 1] < totalPages - 1) items.push(<span key="r-ellipsis" className="px-1 text-gray-400 font-bold">...</span>)
                                    items.push(<button key={totalPages} className={`flex h-9 w-9 items-center justify-center rounded-lg text-sm font-bold transition-all ${currentPage === totalPages ? 'bg-brand-500 text-white shadow-md' : 'text-gray-600 hover:bg-gray-100 dark:text-gray-300 dark:hover:bg-navy-700'}`} onClick={() => setCurrentPage(totalPages)}>{totalPages}</button>)
                                }
                                return items
                            })()}

                            <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(p => p + 1)} className="flex h-9 w-9 items-center justify-center rounded-lg border border-gray-200 bg-white text-gray-500 disabled:opacity-40 hover:bg-gray-50 dark:border-white/10 dark:bg-navy-800 dark:hover:bg-navy-700 transition-all">
                                <IconChevronRight />
                            </button>
                        </div>
                    )}
                </>
            )}

            {/* ── 5. DETAYLI RAPOR ── */}
            {!loading && transactions.length > 0 && (
                <div className="mt-12">
                    <div className="flex items-center gap-3 mb-6">
                        <div className="text-green-500"><IconCheckCircle /></div>
                        <h3 className="text-xl font-bold text-navy-700 dark:text-white">
                            {viewMode === 'today' ? 'Gün Sonu Raporu' : 'Haftalık Rapor'}
                        </h3>
                    </div>

                    <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">

                        {/* ── DÜKKAN ÖZETİ ── */}
                        <div className="bg-white dark:bg-navy-800 p-6 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 pb-2 border-b border-gray-100 dark:border-white/10">🏪 Dükkan Özeti</p>

                            <div className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-white/5">
                                <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2"><IconCash /> Nakit Gelir</span>
                                <span className="text-sm font-bold text-green-500">{formatCurrency(detailedReport.summary.cashIncome)}</span>
                            </div>
                            <div className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-white/5">
                                <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2"><IconCard /> Kart Geliri</span>
                                <span className="text-sm font-bold text-green-500">{formatCurrency(detailedReport.summary.cardIncome)}</span>
                            </div>
                            <div className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-white/5">
                                <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2"><IconCash /> Nakit Gider</span>
                                <span className="text-sm font-bold text-red-500">-{formatCurrency(detailedReport.summary.cashExpense)}</span>
                            </div>
                            <div className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-white/5">
                                <span className="text-sm text-gray-500 dark:text-gray-400 flex items-center gap-2"><IconCard /> Kart Gideri</span>
                                <span className="text-sm font-bold text-red-500">-{formatCurrency(detailedReport.summary.cardExpense)}</span>
                            </div>
                            {detailedReport.summary.totalFees > 0 && (
                                <div className="flex justify-between items-center py-2 border-b border-gray-100 dark:border-white/5">
                                    <span className="text-sm text-gray-500 dark:text-gray-400 italic">✂️ Banka Kesintisi</span>
                                    <span className="text-sm font-bold text-orange-500">-{formatCurrency(detailedReport.summary.totalFees)}</span>
                                </div>
                            )}

                            <div className="h-px bg-gray-100 dark:bg-white/10 my-3" />

                            <div className="flex justify-between items-center py-2">
                                <span className="text-sm font-bold text-green-500">Toplam Ciro</span>
                                <span className="text-base font-black text-green-500">{formatCurrency(detailedReport.summary.totalIncome)}</span>
                            </div>
                            <div className="flex justify-between items-center py-2">
                                <span className="text-sm font-bold text-red-500">Toplam Gider</span>
                                <span className="text-base font-black text-red-500">-{formatCurrency(detailedReport.summary.totalExpense)}</span>
                            </div>

                            <div className="flex justify-between items-center mt-4 p-4 rounded-xl bg-brand-50 dark:bg-brand-400/10">
                                <span className="text-sm font-bold text-brand-500 flex items-center gap-2">
                                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>
                                    Net Kalan
                                </span>
                                <span className={`text-xl font-black ${detailedReport.summary.netProfit >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                                    {formatCurrency(detailedReport.summary.netProfit)}
                                </span>
                            </div>
                        </div>

                        {/* ── POS & BANKA RAPORU ── */}
                        <div className="bg-white dark:bg-navy-800 p-6 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 pb-2 border-b border-gray-100 dark:border-white/10">🏦 POS & Banka Raporu</p>
                            {Object.values(detailedReport.bankStats).filter(b => b.amount > 0 || b.expense > 0).length === 0 ? (
                                <div className="text-center py-10 text-sm text-gray-400">İşlem yok.</div>
                            ) : (
                                <div className="max-h-[400px] overflow-y-auto pr-2 custom-sidebar-scroll">
                                    {Object.values(detailedReport.bankStats).map((bank, idx) =>
                                            (bank.amount > 0 || bank.expense > 0) && (
                                                <div key={idx} className="bg-gray-50 dark:bg-navy-900 rounded-xl p-4 mb-3 border border-gray-100 dark:border-white/5">
                                                    <div className="flex items-center gap-2 mb-3 pb-2 border-b border-gray-200 dark:border-white/10">
                                                        <span className="text-brand-500"><IconBank /></span>
                                                        <span className="text-sm font-bold text-navy-700 dark:text-white">{bank.name}</span>
                                                    </div>
                                                    {bank.amount > 0 && (
                                                        <div className="flex justify-between text-sm mb-1.5">
                                                            <span className="text-gray-500 dark:text-gray-400">Giriş:</span>
                                                            <span className="font-bold text-green-500">{formatCurrency(bank.amount)}</span>
                                                        </div>
                                                    )}
                                                    {bank.expense > 0 && (
                                                        <div className="flex justify-between text-sm mb-1.5">
                                                            <span className="text-gray-500 dark:text-gray-400">Çıkış:</span>
                                                            <span className="font-bold text-red-500">-{formatCurrency(bank.expense)}</span>
                                                        </div>
                                                    )}
                                                    <div className="flex justify-between text-sm mt-2 pt-2 border-t border-gray-200 dark:border-white/10">
                                                        <span className="text-gray-500 dark:text-gray-400">Net Geçen:</span>
                                                        <span className={`font-black ${bank.net >= 0 ? 'text-green-500' : 'text-red-500'}`}>{formatCurrency(bank.net)}</span>
                                                    </div>
                                                </div>
                                            )
                                    )}
                                </div>
                            )}
                        </div>

                        {/* ── PERSONEL KARNE ── */}
                        <div className="bg-white dark:bg-navy-800 p-6 rounded-[20px] shadow-sm border border-gray-100 dark:border-white/10">
                            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-4 pb-2 border-b border-gray-100 dark:border-white/10">👤 Personel Karne</p>
                            {Object.values(detailedReport.staffStats).filter(s => s.income > 0 || s.expense > 0).length === 0 ? (
                                <div className="text-center py-10 text-sm text-gray-400">Hareket yok.</div>
                            ) : (
                                <div className="max-h-[400px] overflow-y-auto pr-2 custom-sidebar-scroll">
                                    {Object.values(detailedReport.staffStats).map((staff, idx) =>
                                            (staff.income > 0 || staff.expense > 0) && (
                                                <div key={idx} className="bg-gray-50 dark:bg-navy-900 rounded-xl p-4 mb-3 border border-gray-100 dark:border-white/5">

                                                    <div className="flex items-center gap-2 mb-4 pb-3 border-b border-gray-200 dark:border-white/10">
                                                        <div className="flex h-8 w-8 items-center justify-center rounded-full bg-orange-50 text-orange-500 dark:bg-orange-500/10">
                                                            <IconUser />
                                                        </div>
                                                        <span className="text-sm font-bold text-navy-700 dark:text-white">{staff.name}</span>
                                                    </div>

                                                    {/* KAZANÇ */}
                                                    <div className="mb-4">
                                                        <p className="text-[10px] font-bold text-green-500 uppercase tracking-widest mb-2">KAZANDIRDIĞI (Ciro)</p>
                                                        <div className="flex justify-between text-sm mb-1">
                                                            <span className="text-gray-500 dark:text-gray-400">Nakit:</span>
                                                            <span className="font-bold text-navy-700 dark:text-white">{formatCurrency(staff.incomeCash)}</span>
                                                        </div>
                                                        {Object.keys(staff.incomeBankBreakdown).length > 0 && (
                                                            <div className="pl-2 ml-1 border-l-2 border-gray-200 dark:border-white/10 mb-2">
                                                                {Object.entries(staff.incomeBankBreakdown).map(([bankId, amount]) => (
                                                                    <div key={bankId} className="flex justify-between text-xs mb-1">
                                                                        <span className="text-gray-400">{detailedReport.bankNameMap[bankId] || 'Kart'}:</span>
                                                                        <span className="font-bold text-brand-500">{formatCurrency(amount)}</span>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        )}
                                                        <div className="flex justify-end text-sm font-bold text-green-500 pt-1 mt-1 border-t border-gray-200 dark:border-white/10">
                                                            {formatCurrency(staff.income)}
                                                        </div>
                                                    </div>

                                                    {/* GİDER */}
                                                    {staff.expense > 0 && (
                                                        <div className="mb-4">
                                                            <p className="text-[10px] font-bold text-red-500 uppercase tracking-widest mb-2">HARCAMASI (Gider/Avans)</p>
                                                            <div className="flex justify-between text-sm mb-1">
                                                                <span className="text-gray-500 dark:text-gray-400">Nakit:</span>
                                                                <span className="font-bold text-navy-700 dark:text-white">-{formatCurrency(staff.expenseCash)}</span>
                                                            </div>
                                                            {Object.keys(staff.expenseBankBreakdown).length > 0 && (
                                                                <div className="pl-2 ml-1 border-l-2 border-gray-200 dark:border-white/10 mb-2">
                                                                    {Object.entries(staff.expenseBankBreakdown).map(([bankId, amount]) => (
                                                                        <div key={bankId} className="flex justify-between text-xs mb-1">
                                                                            <span className="text-gray-400">{detailedReport.bankNameMap[bankId] || 'Kart'}:</span>
                                                                            <span className="font-bold text-red-500">-{formatCurrency(amount)}</span>
                                                                        </div>
                                                                    ))}
                                                                </div>
                                                            )}
                                                            <div className="flex justify-end text-sm font-bold text-red-500 pt-1 mt-1 border-t border-gray-200 dark:border-white/10">
                                                                -{formatCurrency(staff.expense)}
                                                            </div>
                                                        </div>
                                                    )}

                                                    {/* NET KATKI */}
                                                    <div className="flex justify-between items-center bg-brand-50 dark:bg-brand-400/10 p-3 rounded-xl mt-2">
                                                        <span className="text-sm font-bold text-brand-500">Net Katkı:</span>
                                                        <span className={`text-base font-black ${ (staff.income - staff.expense) >= 0 ? 'text-green-500' : 'text-red-500' }`}>
                                                            {formatCurrency(staff.income - staff.expense)}
                                                        </span>
                                                    </div>
                                                </div>
                                            )
                                    )}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}

            {/* ── MODAL: DÜZENLE / SİL ── */}
            <HzModal
                visible={modal.visible}
                onClose={() => !isSubmitting && setModal({ ...modal, visible: false })}
                title={modal.type === 'delete' ? 'İşlemi Sil' : 'İşlemi Düzenle'}
                footer={
                    <>
                        <button className="px-6 py-2.5 rounded-xl text-sm font-bold text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-navy-700 transition-colors" onClick={() => setModal({ ...modal, visible: false })} disabled={isSubmitting}>
                            Vazgeç
                        </button>
                        <button
                            className={`flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-bold text-white shadow-md transition-all active:scale-95 ${modal.type === 'delete' ? 'bg-red-500 hover:bg-red-600 shadow-red-500/30' : 'bg-brand-500 hover:bg-brand-600 shadow-brand-500/30'}`}
                            onClick={saveChanges}
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? <IconSpinner size={16} /> : null}
                            {isSubmitting ? 'İşleniyor...' : modal.type === 'delete' ? 'Evet, Sil' : 'Kaydet'}
                        </button>
                    </>
                }
            >
                {modal.type === 'delete' && modal.data ? (
                    <div className="text-center">
                        <div className="mx-auto flex h-14 w-14 items-center justify-center rounded-full bg-red-50 text-red-500 dark:bg-red-500/10 dark:text-red-400 mb-4">
                            <IconWarning />
                        </div>
                        <h4 className="text-lg font-bold text-navy-700 dark:text-white mb-2">Bu işlemi silmek istiyor musunuz?</h4>
                        <p className="text-sm font-medium text-gray-600 dark:text-gray-300">
                            <strong className="text-navy-700 dark:text-white">"{modal.data.title}"</strong> — {formatCurrency(modal.data.amount)}
                        </p>
                        <p className="text-xs font-bold text-red-500 mt-4">Bu işlem geri alınamaz.</p>
                    </div>
                ) : modal.data ? (
                    <div className="flex flex-col gap-4">
                        <div>
                            <label className="text-xs font-bold text-gray-500 dark:text-gray-400 ml-1 mb-1 block">Başlık</label>
                            <input className="w-full h-11 px-4 rounded-xl border border-gray-200 bg-gray-50 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all" value={modal.data.title} onChange={e => setModal({ ...modal, data: { ...modal.data, title: e.target.value } })} />
                        </div>
                        <div className="grid grid-cols-2 gap-4">
                            <div>
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 ml-1 mb-1 block">Tutar</label>
                                <input type="number" className="w-full h-11 px-4 rounded-xl border border-gray-200 bg-gray-50 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all" value={modal.data.amount} onChange={e => setModal({ ...modal, data: { ...modal.data, amount: e.target.value } })} />
                            </div>
                            <div>
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 ml-1 mb-1 block">Tarih</label>
                                <input type="date" className="w-full h-11 px-4 rounded-xl border border-gray-200 bg-gray-50 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all" value={modal.data.date} onChange={e => setModal({ ...modal, data: { ...modal.data, date: e.target.value } })} />
                            </div>
                        </div>
                        <div>
                            <label className="text-xs font-bold text-gray-500 dark:text-gray-400 ml-1 mb-1 block">Ödeme Yöntemi</label>
                            <HzSelect
                                value={modal.data.payment_method}
                                onChange={v => setModal({ ...modal, data: { ...modal.data, payment_method: v } })}
                                options={[
                                    { value: 'cash', label: '💵 Nakit' },
                                    { value: 'card', label: '💳 Kart / Banka' }
                                ]}
                            />
                        </div>
                        {(modal.data.payment_method === 'card' || modal.data.payment_method === 'transfer') && (
                            <div>
                                <label className="text-xs font-bold text-gray-500 dark:text-gray-400 ml-1 mb-1 block">Banka Hesabı</label>
                                <HzSelect
                                    value={modal.data.bank_account_id}
                                    onChange={v => setModal({ ...modal, data: { ...modal.data, bank_account_id: v } })}
                                    placeholder="Seçiniz..."
                                    options={bankList.map(b => ({ value: b.id, label: b.name }))}
                                />
                            </div>
                        )}
                        <div>
                            <label className="text-xs font-bold text-gray-500 dark:text-gray-400 ml-1 mb-1 block">Açıklama</label>
                            <textarea
                                className="w-full p-4 rounded-xl border border-gray-200 bg-gray-50 text-sm font-bold text-navy-700 outline-none focus:border-brand-500 dark:border-white/10 dark:bg-navy-900 dark:text-white transition-all resize-none"
                                rows={3}
                                value={modal.data.description || ''}
                                onChange={e => setModal({ ...modal, data: { ...modal.data, description: e.target.value } })}
                            />
                        </div>
                    </div>
                ) : null}
            </HzModal>

            {/* Custom Scrollbar eklentisi (opsiyonel) */}
            <style jsx>{`
                .custom-sidebar-scroll::-webkit-scrollbar { width: 4px; }
                .custom-sidebar-scroll::-webkit-scrollbar-track { background: transparent; }
                .custom-sidebar-scroll::-webkit-scrollbar-thumb { background: rgba(163, 174, 208, 0.3); border-radius: 10px; }
                .dark .custom-sidebar-scroll::-webkit-scrollbar-thumb { background: rgba(255, 255, 255, 0.1); }
            `}</style>
        </div>
    )
}

export default Vault_Transaction_History